import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { metaEvent } from "@/lib/tracking";
import { useCamp } from "@/hooks/useCamp";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Included } from "@/components/site/Included";
import { Coaches } from "@/components/site/Coaches";
import { Venue } from "@/components/site/Venue";
import { Pricing } from "@/components/site/Pricing";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";

export default function Home() {
  const camp = useCamp();
  const navigate = useNavigate();
  const onRegister = () => navigate("/register");
  const viewed = useRef(false);
  useEffect(() => {
    if (!camp || viewed.current) return;
    viewed.current = true;
    metaEvent("ViewContent", { contentId: camp.slug, value: camp.price_cents / 100 });
  }, [camp]);
  return (
    <div data-testid="home-page">
      <Header onRegister={onRegister} />
      <Hero camp={camp} onRegister={onRegister} />
      <Coaches />
      <About />
      <Included />
      <Venue />
      <Pricing camp={camp} onRegister={onRegister} />
      <Faq />
      <Footer />
      <MobileBar camp={camp} onRegister={onRegister} />
    </div>
  );
}
